const PARAM_KEYS = {
  userId: "UserId",
  clientId: "ClientId",
  redirectUri: "RedirectUri",
} as const;

export function impersonateUser(userId: string, idsUrl: string) {
  const url = new URL("/Account/ImpersonateExternal", idsUrl);
  url.searchParams.set(PARAM_KEYS.userId, userId);
  url.searchParams.set(PARAM_KEYS.clientId, "Next_App");
  url.searchParams.set(
    PARAM_KEYS.redirectUri,
    `${window.location.origin}/impersonation-callback`
  );
  window.location.href = url.toString();
}

export function exitImpersonation(idsUrl: string) {
  const url = new URL("/Account/BackToImpersonatorExternal", idsUrl);
  url.searchParams.set(PARAM_KEYS.clientId, "Next_App");
  url.searchParams.set(
    PARAM_KEYS.redirectUri,
    `${window.location.origin}/impersonation-callback`
  );
  window.location.href = url.toString();
}
